import IOService from 'pk/service/IOService'

export default class UserSmsApi {
  sendSmsCaptcha (params: { phone: string }) {
    return IOService.post('user_sms/sendSmsCaptcha', params)
  }
}
